import { observer } from 'mobx-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import HeaderPage from '@organisms/common/HeaderPage';
import Board from '@organisms/community/Board';
import { useMobxStores } from '@stores/store';
import { useTranslation } from 'react-i18next';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import FloatArea from '@molecules/FloatArea';
import { setMetaTags } from '@helpers/SeoHelper';
import queryString from 'query-string';

import { isMobileWithOutIpad } from '@helpers/EnvHelper';

import { useWindowSize } from 'usehooks-ts';
import { bgmCodes } from '@stores/SettingStore';
import IntroduceBtn from '@atoms/btn/IntroduceBtn';
import BoardHeader from '@organisms/community/BoardHeader';

const NoticePage = () => {
  const { communityStore } = useMobxStores();

  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { idx } = useParams();
  const [noticeIdx, setNoticeIdx] = useState(0);
  const detailRef = useRef(null);

  const { width } = useWindowSize();

  const getInitialData = useCallback(
    async function (query) {
      if (_has(query, 'idx')) {
        navigate(`/${i18n.language}/community/news/${query.idx}`);
      }

      communityStore.setListQuery('noticeList', {
        ...query,
        page: _has(query, 'page') ? parseInt(query.page) : 1,
        lang: i18n.language,
        size: 6,
        // size : 2,
      });

      await communityStore.getNoticeList();
      if (
        !_isEmpty(communityStore.noticeList) &&
        communityStore.noticeList.query.page > 1 &&
        communityStore.noticeList.totalPages <
          communityStore.noticeList.query.page
      ) {
        navigate('?' + queryString.stringify(query));
      }

      return true;
    },
    [communityStore, i18n.language]
  );

  useEffect(() => {
    const query = queryString.parse(location.search);
    getInitialData(query);
  }, [location, getInitialData]);

  return (
    <>
      <div className="min-h-screen mb-[15px] xl:mb-[70px] relative max-w-[1200px] m-auto">
        <div className="mx-[30px] sm:mx-[60px]">
          <BoardHeader type="news" />
          <Board type="news" />
        </div>
      </div>
    </>
  );
};

export default observer(NoticePage);
